import { Icon } from '@/icons/Icon'

export default function Loader({ size = 32 }: { size?: number }) {
  const iconSize = size > 32 ? 18 : 12

  return (
    <div
      style={{ width: size, height: size }}
      className="flex items-center justify-center text-gray-500"
    >
      <Icon name="loader" size={iconSize} strokeWidth={1} className="animate-spin" />
    </div>
  )
}
